import React from "react";

// Local Stylesheet
import "./SplitFileUploadButton.scss";

function SplitFileUploadButton({
  fileName = "",
  onChange = (file) =>
    console.log("No onChange provided to SplitFileUploadButton"),
  isFileUploadDisabled = false,
}) {
  const inputRef = React.useRef(null);

  const handleClick = () => {
    inputRef.current.click();
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange(file);
    } else {
      onChange(null);
      inputRef.current.value = null;
    }
  };

  return (
    <div className="split-file-upload-button-container">
      <input
        type="file"
        accept=".pdf"
        ref={inputRef}
        onChange={handleChange}
        style={{ display: "none" }}
      />

      <button
        onClick={handleClick}
        className="split-file-upload-button w-100"
        disabled={isFileUploadDisabled}
      >
        <div className="split-file-upload-button-view">
          <div className="d-flex split-file-upload-button-value">
            <div className="text-break">{truncateFileName(fileName)}</div>
          </div>
          <div
            style={{
              color: "#2563EB",
              opacity: isFileUploadDisabled ? 0.5 : 1,
            }}
          >
            Browse
          </div>
        </div>
      </button>
    </div>
  );
}

export default SplitFileUploadButton;

// Helper function
function truncateFileName(fileName) {
  // Remove file extension
  const fileNameWithoutExtension = fileName.split(".").slice(0, -1).join(".");

  // Check if the name contains more than 5 capital letters within the first 15 characters
  const firstFifteenChars = fileNameWithoutExtension.slice(0, 15);
  const capitalLettersCount = (firstFifteenChars.match(/[A-Z]/g) || []).length;

  // Set limit based on the capital letters count
  let limit = 20;
  if (capitalLettersCount > 5) {
    limit = 13;
  }

  // Truncate to the appropriate limit
  if (fileNameWithoutExtension.length > limit) {
    return fileNameWithoutExtension.slice(0, limit) + "...";
  } else {
    return fileNameWithoutExtension;
  }
}
